import { RolexPushBannerImage } from './BannerImage'
import { CleanLink } from '@components/gassan-ui/Link/CleanLink'
import { Heading } from '@components/rolex-ui/Heading'
import { SecondaryCta } from '@components/rolex-ui/SecondaryCta'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { AssetsElement } from '@lib/kontent/models/Elements'
import Link from 'next/link'
import { FC } from 'react'

type RolexPushBannerProps = {
  pretitle?: string
  description?: string
  title: string
  buttonLink: string
  buttonText?: string
  mobileImage: AssetsElement
  desktopImage: AssetsElement
  gridLayout: 'n1_column' | 'n2_columns' | 'n3_columns'
  className?: string
}

export const RolexPushBanner: FC<RolexPushBannerProps> = ({
  pretitle,
  description,
  title,
  buttonLink,
  buttonText,
  mobileImage,
  desktopImage,
  gridLayout,
  className,
}) => {
  return (
    <Link href={buttonLink} passHref legacyBehavior>
      <CleanLink
        className={cn(
          'rounded focus:outline-none focus:ring-2 focus:ring-rolexGreenAlt',
          className,
        )}
      >
        <div className="group flex flex-col items-start gap-[10px]">
          <RolexPushBannerImage
            mobileImage={mobileImage}
            desktopImage={desktopImage}
            gridLayout={gridLayout}
            title={title}
          />
          <div className="flex flex-col items-start lg:max-w-[50vw]">
            {pretitle && (
              <Text
                variant={gridLayout === 'n3_columns' ? 'legend16' : 'fixed16'}
                className={cn('text-rolexBrown')}
              >
                {pretitle}
              </Text>
            )}
            <Heading
              variant="headline36"
              className={cn('mb-[5px] text-rolexBrown', gridLayout === 'n3_columns' && 'hidden')}
            >
              {title}
            </Heading>
            {description && (
              <Text variant="body20" className="mb-2" weight="light">
                {description}
              </Text>
            )}
            <Text
              variant="body24"
              className={cn('mb-1 text-rolexBrown', gridLayout !== 'n3_columns' && 'hidden')}
            >
              {title}
            </Text>
            {buttonText && (
              <SecondaryCta
                as="button"
                iconRight="chevron-right"
                className="group-hover:text-rolexBlack"
              >
                {buttonText}
              </SecondaryCta>
            )}
          </div>
        </div>
      </CleanLink>
    </Link>
  )
}
